import { APICore } from './apiCore';

const api = new APICore();

/**
 * Get the company for the currently active workspace.
 * The workspace is resolved server-side via the X-Workspace-ID header
 * which is already set globally by apiCore.ts whenever the user switches workspaces.
 */
export function getCompany(): Promise<any> {
    return api.get('/company');
}

/**
 * Create or update the company for the currently active workspace (upsert).
 * @param {FormData} companyData
 */
export function updateCompany(companyData: FormData): Promise<any> {
    return api.create('/company', companyData);
}

/**
 * Delete the company for the currently active workspace.
 */
export function deleteCompany(): Promise<any> {
    return api.delete('/company');
}